import axios from "axios";

export default axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? window.location.origin
      : process.env.REACT_APP_API_URL,
});
